import React from 'react';

const Navigation = ({
  activeSection,
  isMenuOpen,
  setIsMenuOpen,
  scrollToSection,
  isDarkMode,
  toggleTheme
}) => {
  return (
    <nav>
      <div className="nav-container">
        <div
          className="logo"
          role="button"
          tabIndex={0}
          onClick={() => scrollToSection('home')}
          onKeyDown={(e) => e.key === 'Enter' && scrollToSection('home')}
        >
          <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Outer Ring */}
            <circle cx="27.5" cy="27.5" r="25" stroke="#00fff7" strokeWidth="2" className="logo-ring"/>
            
            {/* Inner Rotating Circle */}
            <circle cx="27.5" cy="27.5" r="20" stroke="#00d4ff" strokeWidth="1.5" strokeDasharray="4 4" className="logo-inner-ring"/>
            
            {/* Stylized S with tech aesthetic */}
            <path 
              d="M 20 18 Qs28 18 28 23 S 28 27 22 27 L 33 27 Q 27 27 27 32 Q 27 37 35 37" 
              stroke="#00fff7" 
              strokeWidth="3" 
              strokeLinecap="round"
              fill="none"
              className="logo-s"
            />
            
            {/* Corner Accent Brackets */}
            <path d="M 15 15 L 12 15 L 12 18" stroke="#00fff7" strokeWidth="1.5" strokeLinecap="round" className="logo-bracket"/>
            <path d="M 40 15 L 43 15 L 43 18" stroke="#00fff7" strokeWidth="1.5" strokeLinecap="round" className="logo-bracket"/>
            <path d="M 15 40 L 12 40 L 12 37" stroke="#00fff7" strokeWidth="1.5" strokeLinecap="round" className="logo-bracket"/>
            <path d="M 40 40 L 43 40 L 43 37" stroke="#00fff7" strokeWidth="1.5" strokeLinecap="round" className="logo-bracket"/>
            
            {/* Small dots for tech feel */}
            <circle cx="27.5" cy="10" r="1.5" fill="#00fff7" className="logo-dot"/>
            <circle cx="45" cy="27.5" r="1.5" fill="#00fff7" className="logo-dot"/>
            <circle cx="27.5" cy="45" r="1.5" fill="#00fff7" className="logo-dot"/>
            <circle cx="10" cy="27.5" r="1.5" fill="#00fff7" className="logo-dot"/>
          </svg>
        </div>

        <ul className="nav-links" style={{ right: isMenuOpen ? '0' : '-100%' }}>
          <li className={activeSection === 'about' ? 'active' : ''}>
            <button onClick={() => scrollToSection('about')}>
              <span>01.</span> About
            </button>
          </li>
          <li className={activeSection === 'skills' ? 'active' : ''}>
            <button onClick={() => scrollToSection('skills')}>
              <span>02.</span> Skills
            </button>
          </li>
          <li className={activeSection === 'experience' ? 'active' : ''}>
            <button onClick={() => scrollToSection('experience')}>
              <span>03.</span> Experience
            </button>
          </li>
          <li className={activeSection === 'achievements' ? 'active' : ''}>
            <button onClick={() => scrollToSection('achievements')}>
              <span>04.</span> Achievements
            </button>
          </li>
          <li className={activeSection === 'projects' ? 'active' : ''}>
            <button onClick={() => scrollToSection('projects')}>
              <span>05.</span> Projects
            </button>
          </li>
          <li className={activeSection === 'contact' ? 'active' : ''}>
            <button onClick={() => scrollToSection('contact')}>
              <span>06.</span> Contact
            </button>
          </li>
        </ul>

        <div className="nav-right">
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {isDarkMode ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z"/>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z"/>
              </svg>
            )}
          </button>

          <div
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
            role="button"
            tabIndex={0}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            onKeyDown={(e) =>
              e.key === 'Enter' && setIsMenuOpen(!isMenuOpen)
            }
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .logo {
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo:hover {
          transform: scale(1.05);
        }

        .logo-ring {
          transition: all 0.4s ease;
        }

        .logo-inner-ring {
          transition: all 0.4s ease;
          animation: rotate 8s linear infinite;
          transform-origin: center;
        }

        .logo-s {
          transition: all 0.3s ease;
          filter: drop-shadow(0 0 3px rgba(0, 255, 247, 0.3));
        }

        .logo-bracket {
          transition: all 0.3s ease;
          opacity: 0.7;
        }

        .logo-dot {
          transition: all 0.3s ease;
          animation: pulse 2s ease-in-out infinite;
        }

        .logo:hover .logo-ring {
          stroke: #00d4ff;
          filter: drop-shadow(0 0 12px rgba(0, 255, 247, 0.6));
        }

        .logo:hover .logo-inner-ring {
          stroke: #00fff7;
          animation: rotate 3s linear infinite;
        }

        .logo:hover .logo-s {
          stroke: #00d4ff;
          filter: drop-shadow(0 0 8px rgba(0, 255, 247, 0.8));
        }

        .logo:hover .logo-bracket {
          opacity: 1;
          stroke: #00d4ff;
        }

        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            r: 1.5;
          }
          50% {
            opacity: 0.5;
            r: 2;
          }
        }

        .theme-toggle {
          background: transparent;
          border: 2px solid #00fff7;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #00fff7;
          margin-left: 10px;
        }

        .theme-toggle:hover {
          background: rgba(0, 255, 247, 0.1);
          transform: rotate(180deg);
          box-shadow: 0 0 15px rgba(0, 255, 247, 0.3);
        }

        .menu-toggle {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 5px;
        }

        .menu-toggle span {
          width: 25px;
          height: 2px;
          background-color: #00fff7;
          transition: all 0.3s ease;
          display: block;
        }

        .menu-toggle.active span:nth-child(1) {
          transform: rotate(45deg) translate(7px, 7px);
        }

        .menu-toggle.active span:nth-child(2) {
          opacity: 0;
        }

        .menu-toggle.active span:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -7px);
        }

        .nav-links li.active button {
          color: #00fff7;
        }

        .nav-links li.active button span {
          color: #00fff7;
        }

        @media (max-width: 768px) {
          .menu-toggle {
            display: flex;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navigation;